// This icon file is generated automatically.
var PicasaOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M14.12.9v6.68L6.51.65a9.9 9.9 0 017.61.25zM4.85 18.58a10.05 10.05 0 01-4.13-4.85l4.13-3.77v8.62zM0 10.02a9.97 9.97 0 015.44-8.9l3.79 3.43-8.87 8.07c-.23-.86-.36-1.74-.36-2.6zm5.9 4.36h13.08A10.04 10.04 0 0110.91 20H9.08a9.97 9.97 0 01-3.18-.84v-4.78zm9.28-12.9a10.05 10.05 0 014.25 11.84h-4.25V1.47z", "fill-rule": "evenodd" } }] }, "name": "picasa", "theme": "outlined" };
export default PicasaOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PicasaOutlined.js
// module id = 3787
// module chunks = 0